import Delete from './Delete.container';

export default Delete;
